import { gql } from '@apollo/client';

export const GET_TOP_MODEL_NAMES = gql`
  query GetTopModelNames($filters: DistributionGraphsInput) {
    getTopModelNames(input: $filters) {
      amountOfListings
      label
    }
  }
`;
